import { isNorthAmericaCountry } from 'app/modules/fintracStr/formConfig/definitions/common/conditions';
import {
  FINTRAC_STR_CANADA_STATE_CODE_OPTIONS,
  FINTRAC_STR_COUNTRY_CODE,
  FINTRAC_STR_COUNTRY_CODE_OPTIONS,
  FINTRAC_STR_INCORPORATION_TYPE_CODE_OPTIONS,
  FINTRAC_STR_MEXICO_STATE_CODE_OPTIONS,
  FINTRAC_STR_UNITED_STATES_STATE_CODE_OPTIONS,
} from 'app/modules/fintracStr/formConstants';
import { getDependentPaths } from 'app/modules/fintracStr/formUtils';
import {
  FintracFormFieldConditional,
  FintracFormSingleField,
} from 'app/modules/fintracStr/models';
import {
  U21FormFieldTypes,
  U21SelectOptionProps,
} from 'app/shared/u21-ui/components';
import { isUndefined } from 'lodash';

export const fintracStrRegistrationIncorporationFields = (
  basePath: (sectionIndex: number, fieldSectionIndex?: number[]) => string,
  hideIfTrue?: FintracFormFieldConditional,
): FintracFormSingleField[] => [
  {
    type: U21FormFieldTypes.SELECT,
    name: 'typeCode',
    label: 'Registration/Incorporation type code',
    fieldProps: {
      options: FINTRAC_STR_INCORPORATION_TYPE_CODE_OPTIONS,
    },
    mustExistInPayload: false,
    mustHaveValueIfExist: true,
    dependentPaths: (sectionIndex, fieldSectionIndex) =>
      getDependentPaths(
        hideIfTrue ? [hideIfTrue] : undefined,
        undefined,
        sectionIndex,
        fieldSectionIndex,
      ),
    hideIfTrue,
  },
  {
    type: U21FormFieldTypes.TEXT,
    name: 'number',
    label: 'Number',
    mustExistInPayload: false,
    mustHaveValueIfExist: false,
    dependentPaths: (sectionIndex, fieldSectionIndex) =>
      getDependentPaths(
        hideIfTrue ? [hideIfTrue] : undefined,
        undefined,
        sectionIndex,
        fieldSectionIndex,
      ),
    hideIfTrue,
  },
  [
    {
      type: U21FormFieldTypes.SELECT,
      name: 'jurisdictionOfIssueCountryCode',
      label: 'Jurisdiction of issue country code',
      fieldProps: {
        options: FINTRAC_STR_COUNTRY_CODE_OPTIONS,
      },
      mustExistInPayload: false,
      mustHaveValueIfExist: true,
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          hideIfTrue ? [hideIfTrue] : undefined,
          undefined,
          sectionIndex,
          fieldSectionIndex,
        ),
      hideIfTrue,
    },
    {
      type: U21FormFieldTypes.SELECT,
      name: 'jurisdictionOfIssueProvinceStateCode',
      label: 'Jurisdiction of issue province/state code',
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          hideIfTrue ? [hideIfTrue] : undefined,
          [
            `${basePath(sectionIndex, fieldSectionIndex)}.jurisdictionOfIssueCountryCode`,
          ],
          sectionIndex,
          fieldSectionIndex,
        ),
      fieldProps: (flattenedValues, _, sectionIndex, fieldSectionIndex) => ({
        options: ((): U21SelectOptionProps<string>[] => {
          if (isUndefined(sectionIndex)) {
            return [];
          }

          const countryCode: string | undefined =
            flattenedValues[
              `${basePath(sectionIndex, fieldSectionIndex)}.jurisdictionOfIssueCountryCode`
            ];

          switch (countryCode) {
            case FINTRAC_STR_COUNTRY_CODE.CANADA.value:
              return FINTRAC_STR_CANADA_STATE_CODE_OPTIONS;
            case FINTRAC_STR_COUNTRY_CODE.UNITED_STATES.value:
              return FINTRAC_STR_UNITED_STATES_STATE_CODE_OPTIONS;
            case FINTRAC_STR_COUNTRY_CODE.MEXICO.value:
              return FINTRAC_STR_MEXICO_STATE_CODE_OPTIONS;
            default:
              return [];
          }
        })(),
      }),
      mustExistInPayload: false,
      mustHaveValueIfExist: true,
      hideIfTrue: {
        ...hideIfTrue,
        or: [
          ...(hideIfTrue?.or || []),
          {
            path: (sectionIndex, fieldSectionIndex) =>
              `${basePath(sectionIndex, fieldSectionIndex)}.jurisdictionOfIssueCountryCode`,
            conditions: (value) => !isNorthAmericaCountry(value),
          },
        ],
      },
    },
    {
      type: U21FormFieldTypes.TEXT,
      name: 'jurisdictionOfIssueProvinceStateName',
      label: 'Jurisdiction of issue province/state name',
      mustExistInPayload: false,
      mustHaveValueIfExist: false,
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          hideIfTrue ? [hideIfTrue] : undefined,
          [
            `${basePath(sectionIndex, fieldSectionIndex)}.jurisdictionOfIssueCountryCode`,
          ],
          sectionIndex,
          fieldSectionIndex,
        ),
      hideIfTrue: {
        ...hideIfTrue,
        or: [
          ...(hideIfTrue?.or || []),
          {
            path: (sectionIndex, fieldSectionIndex) =>
              `${basePath(sectionIndex, fieldSectionIndex)}.jurisdictionOfIssueCountryCode`,
            conditions: (value) => isNorthAmericaCountry(value),
          },
        ],
      },
    },
  ],
];
